import React, { useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import {
    LayoutDashboard,
    Users,
    Layers,
    CreditCard,
    LogOut,
    Settings,
    ChevronLeft,
    Shield,
    Package,
    Tag,
    Cpu,
    Flag,
    Target,
    Activity
} from 'lucide-react';
import './AdminLayout.css';

function AdminLayout({ children }) {
    const { admin, logout } = useAdminAuth();
    const navigate = useNavigate();
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    const handleLogout = async () => {
        await logout();
        navigate('/admin/login');
    };

    const navItems = [
        { path: '/admin/dashboard', icon: LayoutDashboard, label: 'Overview' },
        { path: '/admin/users', icon: Users, label: 'Users' },
        { path: '/admin/workspaces', icon: Layers, label: 'Workspaces' },
        { path: '/admin/apps', icon: Package, label: 'Apps' },
        { path: '/admin/goals', icon: Target, label: 'Test Goals' },
        { path: '/admin/runs', icon: Activity, label: 'Test Runs' },
        { path: '/admin/subscriptions', icon: CreditCard, label: 'Subscriptions' },
        { path: '/admin/ai-usage', icon: Cpu, label: 'AI Usage' },
        { path: '/admin/coupons', icon: Tag, label: 'Coupons' },
        { path: '/admin/feature-flags', icon: Flag, label: 'Feature Flags' },
        { path: '/admin/devices', icon: Cpu, label: 'Active Devices' },
    ];

    if (admin?.isSuperAdmin) {
        navItems.push({ path: '/admin/admins', icon: Shield, label: 'Admins' });
    }

    return (
        <div className={`admin-layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
            {/* Sidebar */}
            <aside className="admin-sidebar">
                <div className="admin-sidebar-header">
                    <div className="admin-logo">
                        <Shield size={24} color="#38bdf8" />
                        {!sidebarCollapsed && <span>ROVA ADMIN</span>}
                    </div>
                    <button
                        className="admin-sidebar-toggle"
                        onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                    >
                        <ChevronLeft size={16} />
                    </button>
                </div>

                <nav className="admin-sidebar-nav">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            className={({ isActive }) =>
                                `admin-nav-item ${isActive ? 'active' : ''}`
                            }
                        >
                            <item.icon size={20} />
                            {!sidebarCollapsed && <span>{item.label}</span>}
                        </NavLink>
                    ))}
                </nav>

                <div className="admin-sidebar-footer">
                    <div className="admin-user-info">
                        <div className="admin-avatar">
                            {admin?.fullName?.[0] || admin?.email?.[0] || 'A'}
                        </div>
                        {!sidebarCollapsed && (
                            <div className="admin-details">
                                <span className="admin-name">{admin?.fullName || 'Admin'}</span>
                                <span className="admin-email">{admin?.email}</span>
                            </div>
                        )}
                    </div>
                    <button className="admin-logout-btn" onClick={handleLogout}>
                        <LogOut size={18} />
                        {!sidebarCollapsed && <span>Sign Out</span>}
                    </button>
                </div>
            </aside>

            {/* Main Content */}
            <main className="admin-main-content">
                {/* <header className="admin-top-header">
                    <div className="admin-header-left">
                        <h1>Admin Control Panel</h1>
                    </div>
                    <div className="admin-header-right">
                        <Link to="/settings" className="admin-settings-link">
                            <Settings size={18} />
                        </Link>
                    </div>
                </header> */}

                <section className="admin-page-content">
                    {children}
                </section>
            </main>
        </div>
    );
}

export default AdminLayout;
